import styled from 'styled-components';
import { rem } from 'polished';
import Icon from '../Icon';

const StyledIcon = styled(Icon)`
  margin-bottom: ${rem('2px')};
  transition: none;
  width: ${rem('48px')};
`;

const StyledIconDark = StyledIcon.extend``;

const StyledText = styled.span`
  color: ${props => props.theme.colors.light};
  display: block;
  font-family: ${props => props.theme.fonts.medium};
  font-size: ${props => props.theme.fontSize.xsmall};
  line-height: ${rem('12px')};
  text-align: center;
  max-width: ${rem('95px')};
`;

const StyledTextDark = StyledText.extend`
  color: ${props => props.theme.colors.dark};
`;

const Styledbox = styled.span`
  cursor: pointer;
  display: block;
  text-align: center;

  &.fill {
    ${StyledIconDark} {
      fill: ${props => props.theme.colors.light};
    }
  }

  .App-icon {
    color: ${props => props.theme.colors.dark};
  }

  &:hover,
  &.fill:hover {
    .App-icon {
      color: ${props => props.theme.colors.primary};
      fill: ${props => props.theme.colors.primary};
    }

    .App-text {
      color: ${props => props.theme.colors.primary};
    }
  }
`;

export { StyledIcon, StyledIconDark, Styledbox, StyledText, StyledTextDark };
